import { createContext, use, useState } from "react";

type MenuCollapseType = {
  isMenuCollapsed: boolean;
  setIsMenuCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  toggleMenuCollapse: () => void;
};

const MenuCollapseContext = createContext<MenuCollapseType | undefined>(undefined);

export const MenuCollapseProvider = ({ children }: { children: React.ReactNode }) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState<boolean>(false);

  const toggleMenuCollapse = () => setIsMenuCollapsed((prev) => !prev);

  return (
    <MenuCollapseContext value={{ isMenuCollapsed, setIsMenuCollapsed, toggleMenuCollapse }}>
      {children}
    </MenuCollapseContext>
  );
};

export const useMenuCollapse = () => {
  const context = use(MenuCollapseContext);

  if (!context) {
    throw new Error("useMenuCollapse must be used within a MenuCollapseProvider");
  }

  return context;
};
